import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "content", "icon"]

  toggle(event) {
    const index = event.currentTarget.dataset.index
    const content = this.contentTargets[index]
    const icon = this.iconTargets[index]

    if (content.style.maxHeight && content.style.maxHeight !== "0px") {
      content.style.maxHeight = "0px"
      icon.classList.remove("rotate-180")
    } else {
      content.style.maxHeight = content.scrollHeight + "px"
      icon.classList.add("rotate-180")
    }
  }
}
